// Shared map-overlay thumbnail tile used by PCA and Terrain panels.
// Module-level component (not nested) so React preserves DOM/state across renders.
export const OverlayTile = ({ k, name, png, sub, bbox, prefix, setOverlay, activeOverlayKey }) => png ? (
  <button onClick={() => setOverlay(activeOverlayKey === k ? null : { key: k, png, bbox })}
    className={`border rounded-md p-2 text-left ${activeOverlayKey === k ? "border-primary bg-primary/5" : "border-border"}`} data-testid={`${prefix}-${k}`}>
    <img src={png} alt={name} className="w-full h-14 object-cover rounded" style={{ imageRendering: "pixelated" }} />
    <div className="text-[11px] font-medium mt-1">{name}</div>
    {sub && <div className="text-[10px] text-muted-foreground font-mono">{sub}</div>}
  </button>
) : null;
